import request from '@/utils/axios.js'

export function getList (data) {
  return request({
    url: '/wallet/openAPI/account/wallet/queryUserStepsInfo',
    method: 'post',
    data: data
  })
}

export function uploadImg (data) {
  return request({
    url: '/manageApp/mobileAPI/share/greeting',
    method: 'post',
    data: data
  })
}
